module.exports = __webpack_public_path__ + "static/media/fMINUTA CANCELACION HIPOTECA FINAL.5c9088cf.pdf";